module.exports = __webpack_public_path__ + "img/card-icon.62248181.svg";